import { useRouter } from "next/router";
import { CheckoutUser } from "../types/checkout";
import { RootStateContext } from "../states/root.state";
import { useContext } from "react";
import { CustomerItem } from "../types/customer";

export default function useNavToNewOrder() {
  const { push } = useRouter();
  const { checkoutService } = useContext(RootStateContext);

  function navToNewOrder(customer: CustomerItem, cleanUp?: () => void) {
    const checkoutUser: CheckoutUser = {
      id: customer.id,
      name: customer.name || `${customer.firstName} ${customer.lastName}`,
      email: customer.email,
      mobile: customer.mobileNumber,
    };

    checkoutService.send({
      type: "RESET_XSTATE",
    });

    checkoutService.send({
      customer: checkoutUser,
      type: "ASSIGN_CUSTOMER",
    });

    if (cleanUp) {
      cleanUp();
    }

    push("/");
  }

  return navToNewOrder;
}
